import React, { useState } from 'react'
import { View } from 'react-native'
import Icon from 'react-native-vector-icons/MaterialIcons'
import styled from 'styled-components/native'

// Components
import Button from 'APP/Converse/Button'
import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'
import Typography from 'APP/Converse/Typography'

// Services
import I18n from 'APP/I18n'

// Styles
import { useTheme } from 'styled-components/native'

const Container = styled(View)`
  flex-grow: 0;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.metrics.baseMargin + 2}px;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin + 2}px;
  padding-bottom: ${({ theme }) => theme.insets.bottom}px;
`

const ChoicesContainer = styled(View)`
  display: flex;
  shadow: ${({ theme }) => theme.shadows.soft};
`

const ChoiceText = styled(Typography)`
  text-align: left;
  padding-left: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  flex-shrink: 1;
  color: ${({ theme, disabled }) => (disabled ? theme.colors.textDisabled : theme.colors.text)};
`

const StyledTouchableOpacity = styled(DialogueTouchableOpacity)`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 240px;
  margin-bottom: ${({ isLast }) => (isLast ? 0 : 1)}px;
  background-color: ${({ theme, selected }) =>
    selected ? theme.colors.selected : theme.colors.elementsBg};
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
  // applies border radius if it's the first choice
  border-top-left-radius: ${({ theme, isFirst }) =>
    isFirst ? theme.metrics.borderRadius.medium : 0}px;
  border-top-right-radius: ${({ theme, isFirst }) =>
    isFirst ? theme.metrics.borderRadius.medium : 0}px;
  // applies border radius if it's the last choice
  border-bottom-left-radius: ${({ theme, isLast }) =>
    isLast ? theme.metrics.borderRadius.medium : 0}px;
  border-bottom-right-radius: ${({ theme, isLast }) =>
    isLast ? theme.metrics.borderRadius.medium : 0}px;
`

const ActionsContainer = styled(View)`
  display: flex;
  margin: ${({ theme }) => theme.metrics.baseMargin}px;
`

const IntakeMultiChoice = ({
  choices: choicesProp,
  maximum_selection,
  minimum_selection = 0,
  disabled,
  sendAnswer,
}) => {
  const [choices, setChoices] = useState([])
  const theme = useTheme()
  const onNextPress = () => sendAnswer(choices)
  const onChoicePressed = (choice) => {
    setChoices((prevChoices) => {
      let newChoices = prevChoices.filter((c) => c.group_id === choice.group_id)
      const indexOfChoice = newChoices.indexOf(choice)
      if (indexOfChoice === -1 && (!maximum_selection || newChoices.length < maximum_selection)) {
        newChoices.push(choice)
      } else {
        newChoices.splice(indexOfChoice, 1)
      }
      return newChoices
    })
  }

  return (
    <Container>
      <ChoicesContainer>
        {choicesProp.map((choice, i, array) => {
          const selected = choices.indexOf(choice) > -1
          const isChoiceDisabled =
            disabled || (maximum_selection && maximum_selection === choices.length && !selected)
          return (
            <StyledTouchableOpacity
              key={i}
              isFirst={i === 0}
              isLast={i === array.length - 1}
              selected={selected}
              disabled={isChoiceDisabled}
              onPress={() => onChoicePressed(choice)}
              analyticsName="Choice pressed"
            >
              <Icon
                name={selected ? 'check-box' : 'check-box-outline-blank'}
                color={selected ? theme.colors.text : theme.colors.disabled}
                size={theme.fonts.fontSize.large}
              />
              <ChoiceText variant="bodyNormal" disabled={disabled}>
                {choice.display}
              </ChoiceText>
            </StyledTouchableOpacity>
          )
        })}
      </ChoicesContainer>
      <ActionsContainer>
        <Button
          disabled={disabled || (choices && choices.length < minimum_selection)}
          variant="primary"
          widthVariant="full"
          analyticsName="IntakeComponent.multichoice.next"
          title={I18n.t('IntakeComponent.next')}
          onPress={onNextPress}
        />
      </ActionsContainer>
    </Container>
  )
}

export default IntakeMultiChoice
